import React from 'react';
import { motion } from 'framer-motion';
import { Download, ExternalLink, FileCode } from 'lucide-react';
import { Button } from '../ui/Button';
const sdks = [{
  name: 'Node.js',
  icon: '📦',
  version: 'v2.1.0'
}, {
  name: 'Python',
  icon: '🐍',
  version: 'v1.8.0'
}, {
  name: 'Go',
  icon: '🔷',
  version: 'v1.5.0'
}];
const tools = [{
  name: 'Postman Collection',
  icon: FileCode,
  description: 'Import all endpoints'
}, {
  name: 'OpenAPI Spec',
  icon: FileCode,
  description: 'Generate client code'
}];
export function SDKsTooling() {
  return <section className="py-20 bg-white" data-id="element-586">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-587">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-12" data-id="element-588">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-589">
            SDKs & Tooling
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-590">
            Official libraries and tools to accelerate development.
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto" data-id="element-591">
          {/* SDKs */}
          <div className="mb-12" data-id="element-592">
            <h3 className="text-sm font-semibold text-slate-900 uppercase tracking-wider mb-4" data-id="element-593">
              Official SDKs
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-594">
              {sdks.map((sdk, index) => <motion.div key={sdk.name} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="bg-slate-50 border border-slate-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all" data-id="element-595">
                  <div className="flex items-center gap-3 mb-4" data-id="element-596">
                    <span className="text-3xl" data-id="element-597">{sdk.icon}</span>
                    <div data-id="element-598">
                      <h4 className="font-semibold text-slate-900" data-id="element-599">
                        {sdk.name}
                      </h4>
                      <span className="text-xs text-slate-500" data-id="element-600">
                        {sdk.version}
                      </span>
                    </div>
                  </div>
                  <div className="flex gap-2" data-id="element-601">
                    <Button variant="secondary" size="sm" className="flex-1" data-id="element-602">
                      <Download className="w-3 h-3 mr-1" data-id="element-603" />
                      Download
                    </Button>
                    <Button variant="outline" size="sm" data-id="element-604">
                      <ExternalLink className="w-3 h-3" data-id="element-605" />
                    </Button>
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Tools */}
          <div data-id="element-606">
            <h3 className="text-sm font-semibold text-slate-900 uppercase tracking-wider mb-4" data-id="element-607">
              Developer Tools
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-608">
              {tools.map((tool, index) => <motion.div key={tool.name} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="bg-slate-50 border border-slate-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all" data-id="element-609">
                  <div className="flex items-start justify-between mb-4" data-id="element-610">
                    <div data-id="element-611">
                      <h4 className="font-semibold text-slate-900 mb-1" data-id="element-612">
                        {tool.name}
                      </h4>
                      <p className="text-sm text-slate-600" data-id="element-613">
                        {tool.description}
                      </p>
                    </div>
                    <tool.icon className="w-6 h-6 text-slate-400" data-id="element-614" />
                  </div>
                  <div className="flex gap-2" data-id="element-615">
                    <Button variant="secondary" size="sm" className="flex-1" data-id="element-616">
                      <Download className="w-3 h-3 mr-1" data-id="element-617" />
                      Download
                    </Button>
                    <Button variant="outline" size="sm" data-id="element-618">
                      Docs
                    </Button>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}